import type { ActionHandler } from './types';

export const goToUrlHandler: ActionHandler = {
  type: 'go_to_url',
  execute(ctx) {
    const url = ctx.config.url;
    if (!url) return { navigated: false };
    if (ctx.config.open_in_new_tab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = url;
    }
    return { navigated: true };
  },
};
